import { HTMLAttributes } from 'react';

export type IContainerProps = HTMLAttributes<HTMLDivElement>;

const Container = ({ children }: IContainerProps) => <div className="p-4 md:container md:mx-auto">{children}</div>;

export default Container;
